export enum BankingContextType {
  Personal = "personal",
  Business = "business",
}

export type BankingContext =
  | { type: BankingContextType.Personal }
  | { type: BankingContextType.Business; entityId: string };

export const PERSONAL_BANKING_CONTEXT: BankingContext = { type: BankingContextType.Personal };
